import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { EventSection } from 'src/components/calendar/eventSection'
import { LoadingContent } from 'src/components/loading-content/LoadingContent'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'
import { CollapsibleHTMLContent } from './CollapsibleHTMLTextContent/CollapsibleHTMLContent'
import { DESCRIPTION_ID, DESCRIPTION_SANITIZATION_CONFIG } from './constants'

import locale from './locale'

const style = require('./Description.css')

interface Props {
  eventData: any,
  isMobile: Boolean,
  loading: Boolean,
}

export const DescriptionPlaceholder = () => (
  <LoadingPlaceholder modifierClass={style.placeholder}>
    <LoadingContent width="170px" height="25px" borderRadius="rounder" />

    <LoadingContent height="14px" />
    <LoadingContent height="14px" />
    <LoadingContent height="14px" />
    <LoadingContent width="80%" height="14px" />

    <LoadingContent height="14px" />
    <LoadingContent height="14px" />
    <LoadingContent width="80%" height="14px" />
  </LoadingPlaceholder>
)

const DescriptionComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  isMobile,
  loading,
  intl: { formatMessage },
}) => {
  if (loading) return <DescriptionPlaceholder />
  return (
    <EventSection sectionId={DESCRIPTION_ID} heading={formatMessage(locale.description)}>
      <CollapsibleHTMLContent
        htmlContent={eventData.description}
        htmlSanitizationConfig={DESCRIPTION_SANITIZATION_CONFIG}
        isMobile={isMobile}
      />
    </EventSection>
  )
}

export const Description = injectIntl(DescriptionComponent)
